import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackPurchaseProtectionLearnMorePayload = TrackingPayload & {
    description: string;
};

export const trackPurchaseProtectionLearnMoreAnalytics = (
    eventName: string,
    payload: TrackPurchaseProtectionLearnMorePayload
) => {
    track(eventName, payload);
};

export const useTrackPurchaseProtectionLearnMoreAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (eventName: string, { description }: Omit<TrackPurchaseProtectionLearnMorePayload, 'pageName' | 'url'>) => {
            trackPurchaseProtectionLearnMoreAnalytics(eventName, {
                description,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
